/** t218u: a priority flag in its colour (shared PRIORITY_COLOUR), with an accessible name; colour is never the only cue. */
import { Flag } from 'lucide-react';
import { PRIORITY_COLOUR, PRIORITY_LABEL, type TaskPriority } from '@tradeoutlet/shared';

export function PriorityFlag({ priority, className = 'h-4 w-4' }: { priority: TaskPriority; className?: string }) {
  return <Flag className={className} style={{ color: PRIORITY_COLOUR[priority] }} fill={priority === 'none' ? 'none' : PRIORITY_COLOUR[priority]} role="img" aria-label={`Priority: ${PRIORITY_LABEL[priority]}`} data-priority={priority} />;
}
